// AXIOS SETUP
import Vue from 'vue';
import axios from "axios"
import { store } from "./store-init"
import { langUserGet } from "./utils"

const version = "0.9.4"; // Contenidos estáticos y API v1.12.0, ajuste ligero de botón de WhatsApp.
const mode = "prod"; // [docker|dev|alpha|prod]  

let mainServer,
	localDNS = 'pibvallarta.org',
    publicWebURI = 'https://web.dantrix.pro',
    isDev = false;

switch (mode) {
    case 'prod':
        mainServer = 'https://api.dantrix.pro/sites';
        publicWebURI = 'http://localhost:8080';
        isDev = true;
        Vue.config.productionTip = false;
        break;
    case 'docker':
        mainServer = 'http://localhost:8001/sites-api';
        publicWebURI = 'http://localhost:8080';
        isDev = true;
        Vue.config.productionTip = false;
        break;
}

const apiURIMain = mainServer + '/img/render/';

axios.defaults.maediaImageRender = apiURIMain;
// axios.defaults.maediaImageRender = mainServer + '/index.php?r=img/render/';
axios.defaults.timeout = 30000
axios.defaults.withCredentials = false;
axios.defaults.switchAPI = (waty) => {
    switch (waty) {
        case 'consumer':
            axios.defaults.baseURL = mainServer + '/api'
            // axios.defaults.baseURL = mainServer + '/index.php?r=api'
            axios.defaults.isSales = false
            break;
    }
}
axios.defaults.switchAPI('consumer')

axios.interceptors.request.use((config) => {

    // Do something before request is sent
    config.headers['Content-Type'] = 'application/json';

	// Add auth token header for API requests
    if (store.getters.accountGetToken)
        config.headers['AUTH-TOKEN'] = store.getters.accountGetToken;
    else if (typeof config.headers['AUTH-TOKEN'] != 'undefined')
        delete config.headers['AUTH-TOKEN'];

	// Add working DNS header for API requests
	config.headers['Working-DNS'] = localDNS;
	config.headers['Working-LANG'] = langUserGet();

	// Remove X-Requested-With header if it exists... It can cause CORS issues with some servers...
    if (axios.defaults.headers.common && axios.defaults.headers.common['X-Requested-With'])
        delete axios.defaults.headers.common['X-Requested-With'];

    return config;

}, (error) => {
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use((response) => {
    // Do something with response data
    let returnable = response.data
    return returnable
}, (error) => {
    // Do something with response error
    return Promise.reject(error);
});

export { isDev, mainServer, version, publicWebURI }